export const radiuses = {
  lg: '10px',
  md: '5px',
  sm: '4px',
};
